import {SearchResponseApiModel} from "../../search/models/search-response-api-model";

export class RelatedEntitiesResponseApiModel extends SearchResponseApiModel {
}
